var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragndrop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2C1.55228 2 2 1.55228 2 1C2 0.447715 1.55228 0 1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2Z",
    fill: "#EBEDF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5C6 5.55 5.55 6 5 6C4.45 6 4 5.55 4 5C4 4.45 4.45 4 5 4C5.55 4 6 4.45 6 5ZM1 4C0.45 4 0 4.45 0 5C0 5.55 0.45 6 1 6C1.55 6 2 5.55 2 5C2 4.45 1.55 4 1 4ZM9 4C8.45 4 8 4.45 8 5C8 5.55 8.45 6 9 6C9.55 6 10 5.55 10 5C10 4.45 9.55 4 9 4ZM5 0C4.45 0 4 0.45 4 1C4 1.55 4.45 2 5 2C5.55 2 6 1.55 6 1C6 0.45 5.55 0 5 0ZM9 0C8.45 0 8 0.45 8 1C8 1.55 8.45 2 9 2C9.55 2 10 1.55 10 1C10 0.45 9.55 0 9 0ZM5 8C4.45 8 4 8.45 4 9C4 9.55 4.45 10 5 10C5.55 10 6 9.55 6 9C6 8.45 5.55 8 5 8ZM1 8C0.45 8 0 8.45 0 9C0 9.55 0.45 10 1 10C1.55 10 2 9.55 2 9C2 8.45 1.55 8 1 8ZM9 8C8.45 8 8 8.45 8 9C8 9.55 8.45 10 9 10C9.55 10 10 9.55 10 9C10 8.45 9.55 8 9 8Z",
    fill: "#EBEDF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragndrop);
export default __webpack_public_path__ + "static/media/dragndrop.006d9edef7dada747c5a1da610beb3f0.svg";
export { ForwardRef as ReactComponent };